import { DocumentCreateButtonInfo } from "../items";
import { ReceptionCommentDispInfo } from "../reference";
import { ReceptionDispInfo } from "..";
import { ReceptionReferenceKinds } from "../kinds";

// 診断書WF一覧画面表示用基底model
export class ReceptionListDispInfoBase {
  constructor() {
    this.labelSetting = new ReceptionDispInfo();
    this.commentSetting = new ReceptionCommentDispInfo();
    this.isRequestSheetEnable = false;
    this.loadingChunkSize = 50;
    this.documentCreateButtons = null;
    this.isNewReceptionButtonEnable = true;
    this.isDocumentListButtonEnable = true;
    this.isManagerHistorySearchEnable = false;
    this.defaultSelectedContentTab = null;
    this.shouldTakeOverPatientNoFromMainView = false;
    this.shouldShowManagerPhoneNumber = false;
    this.shouldShowCsvDownloadButton = true;
    this.shouldShowListPrintButton = false;
  }

  // ラベル表示設定
  public labelSetting: ReceptionDispInfo;

  // コメント表示設定
  public commentSetting: ReceptionCommentDispInfo;

  // 依頼書運用有無
  public isRequestSheetEnable: boolean;

  // 一覧読込み行数
  public loadingChunkSize: number;

  // 直接記載用ボタン設定
  public documentCreateButtons: DocumentCreateButtonInfo[];

  // 新規依頼作成ボタン有効フラグ
  public isNewReceptionButtonEnable: boolean;

  // 過去一覧ボタン有効フラグ
  public isDocumentListButtonEnable: boolean;

  // 対応責任者履歴検索有効フラグ
  public isManagerHistorySearchEnable: boolean;

  // デフォルト選択コンテント（右側）タブ
  public defaultSelectedContentTab: ReceptionReferenceKinds;

  // WF一覧の検索患者番号を新規依頼作成時に引き継ぐフラグ
  public shouldTakeOverPatientNoFromMainView: boolean;

  // 応責任者の氏名のあとに電話番号も表示するかどうか
  public shouldShowManagerPhoneNumber: boolean;

  // CSV出力ボタンの表示有無
  public shouldShowCsvDownloadButton: boolean;

  // CSV印刷ボタンの表示有無
  public shouldShowListPrintButton: boolean;
}
